import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { GameState } from "./GameState";

export class GameOverLayer extends Phaser.Group {

    private gameOverLabel: Phaser.BitmapText;
    private tryAgainLabel: Phaser.BitmapText;
    
    constructor(game: Phaser.Game) {

        super(game, null, "game-over-layer");

        const backgroundSprite = new Phaser.Sprite(this.game, 0, 0, this.game.cache.getBitmapData("lila-square"));
        backgroundSprite.scale.setTo(GameConstants.GAME_WIDTH / 16, GameConstants.GAME_HEIGHT / 16);
        backgroundSprite.alpha = 0;
        this.add(backgroundSprite);
        
        this.game.add.tween(backgroundSprite)
            .to({alpha: .8 }, 450, Phaser.Easing.Cubic.Out, true);
            
        const looksLike = new Phaser.BitmapText(this.game, GameConstants.GAME_WIDTH / 2, 220, "marker-felt", "it looks like it's", 40);
        looksLike.scale.x = GameVars.scaleX;
        looksLike.x -= looksLike.width / 2;
        looksLike.alpha = 0;
        this.add(looksLike);
        
        this.gameOverLabel = new Phaser.BitmapText(this.game, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "beacon", "game over", 150);
        this.gameOverLabel.anchor.setTo(.5, .5);
        this.gameOverLabel.scale.x = GameVars.scaleX;
        this.gameOverLabel.alpha = 0;
        this.add(this.gameOverLabel);
        
        this.tryAgainLabel = new Phaser.BitmapText(this.game, GameConstants.GAME_WIDTH / 2, 430, "marker-felt", "but we can try again", 40);
        this.tryAgainLabel.scale.x = GameVars.scaleX;
        this.tryAgainLabel.x -= this.tryAgainLabel.width / 2;
        this.tryAgainLabel.alpha = 0;
        this.add(this.tryAgainLabel);
                
        this.game.add.tween(looksLike)
            .to({alpha: 1}, 450 , Phaser.Easing.Cubic.Out, true, 850)
            .onComplete.add(function(): void {
                    this.game.add.tween(this.gameOverLabel)
                    .to({alpha: 1}, 450 , Phaser.Easing.Cubic.Out, true, 450)
                    .onComplete.add(function(): void {
                
                            this.game.add.tween(this.tryAgainLabel)
                            .to({alpha: 1 }, 450 , Phaser.Easing.Cubic.Out, true, 450)
                            .onComplete.add(function(): void {
                        
                        this.gameOver();
                    }, this);
            }, this);
            }, this);
    }
    
    private gameOver(): void {
        
        this.game.time.events.add(3600, function(): void {
                GameState.currentInstance.replay();
        }, this);
    }
}
